__turbopack_context__.v({
  "className": "manrope_181e2e6a-module__Wd2ljq__className",
});
